import React from 'react'
import colors from '../../../constants/colors'

type IProps = {
  isInverted?: boolean
}

const Send: React.FC<IProps> = ({ isInverted }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path
        d='M2.01 21L23 12 2.01 3 2 10l15 2-15 2z'
        fill={isInverted ? colors.primary : colors.secondary}
      />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export default Send
